module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/babel-runtime/regenerator/index.js
// module id = 1316
// module chunks = 0